import React, {  } from 'react';
import { List } from 'antd-mobile';

const Item = List.Item;

const list = (data, columns) => (
    <List className="my-list">
        {data.map((e, idx) => (
            <Item key={idx} multipleLine extra={columns[columns.length - 1].render("", e, idx)} align="top" wrap>
                {columns[0].render("", e, idx)}
                {columns.filter((el, inx) => inx > 0 && inx < columns.length - 1).map((element, i) => {
                    return <div key={i}>{element.render("", e, idx)}</div>
                })}
            </Item>
        ))}
    </List>
);

export default function(props) {
    const {data, columns} = props;
    return (
        <>
            {list(data, columns)}
        </>
    )
};